import React, { useRef, useEffect } from "react";

const Modal = ({
  isOpen,
  onClose,
  children,
  contentClassName = "bg-white rounded-md shadow-2xl w-full max-w-4xl p-0 relative",
}) => {
  const modalRef = useRef(null);

  // Close when clicking outside the modal content
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose(); // Call the onClose prop instead of internal state
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  return (
    <div className=" ">
      {isOpen && (
        <div className="fixed inset-0 z-50 overflow-y-auto bg-black bg-opacity-50">
          <div className="flex min-h-full items-center justify-center px-0 md:px-4 lg:px-4 py-4">
            <div ref={modalRef} className={contentClassName}>
              <span className=" text-white opacity-0"> heading </span>
              <button
                onClick={onClose}
                className="absolute top-2 right-4 z-20 text-2xl text-gray-500 hover:text-gray-800"
              >
                &times;
              </button>
              {children}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export { Modal };
export default Modal;
